import { Component, HostBinding, OnInit } from "@angular/core"
import { Order } from "src/app/shared/models/order";
import { OrderService } from "src/app/shared/services/order-service";
import { CartService } from "src/app/shared/services/cart-service";
import { MatDialogConfig, MatDialog } from "@angular/material"
import { OrderTypeService } from "src/app/shared/services/order-type-service";
import { Router } from "@angular/router";

@Component({
  selector: "app-shopping-cart",
  templateUrl: "./shopping-cart.component.html",
  styleUrls: ["./shopping-cart.component.scss"],
})
export class ShoppingCartComponent implements OnInit {
  @HostBinding("class.empty") public isEmpty: boolean;

  constructor(
    private orderService: OrderService,
    private cartService: CartService,
    private orderTypeService: OrderTypeService,
    private dialog: MatDialog,
    private router:Router
  ) {}
  order: Order;
  ngOnInit() {
    this.orderService
      .getOrder()
      //   .pipe(takeUntil())
      .subscribe((order: Order) => {
        this.order = order;
        this.isEmpty = this.order.items.length === 0;
      });
  }
  eventFromRadio(event) {
    if (event === "TA" && this.order.orderType !== "TA") {
      this.orderTypeService.chooseOrderType("TA", false);
    }
    if (event === "delivery" && this.order.orderType !== "delivery") {
      this.orderTypeService.chooseOrderType("delivery", false);
    }
  }

  eventFromCarts(event, item) {

    if (event === "plus") {
      this.cartService.changeItemCount(item, 1);
    }
    if (event === "minus") {
      this.cartService.changeItemCount(item, -1);
    }
    if (event === "edit") {
    }
    if (event === "delete") {
      this.cartService.removeLocalCartProduct(item);
    }
  }
  submit(){
    this.router.navigate(["phone"]);
    this.cartService.setCart();
  }
}
